import { render, staticRenderFns } from "./PortalViewConsumos.vue?vue&type=template&id=df9d80f0&"
import script from "./PortalViewConsumos.vue?vue&type=script&lang=js&"
export * from "./PortalViewConsumos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports